// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"124":"2d122b303430b567fde3","256":"dc1338d842c0bd174f36","742":"72a250ddd534b37f35af","772":"8d02bad22f82a74660e2","803":"b8b97dbf88093691f7d5"}[chunkId] + ".js";
};